export const config = {
  useOneIOLogin: process.env.REACT_APP_useOneIOLogin === 'true',
  OneIOLoginURL: `${process.env.REACT_APP_OneIOLoginURL}?redirect_to=${window.location.href}&consentNames=NVIEW-Terms&consentFiles=${window.location.origin}/terms/NVIEW-TermsAndPrivacy-26.03.2025-V1.pdf`,
  OneIOLoginURLWithoutConsent: `${process.env.REACT_APP_OneIOLoginURL}?redirect_to=${window.location.href}`,
  cookieDomain: process.env.REACT_APP_cookieDomain,
  jwtTokenCookieName: process.env.REACT_APP_jwtTokenCookieName ?? '',
  privacyCookieName: process.env.REACT_APP_privacyCookieName,
  nviewAPIUrl: process.env.REACT_APP_NVIEW_API_URL,
  mqttURL: process.env.REACT_APP_MQTT_URL ?? '',
};
